import * as React from "react";
import styled, { css } from "styled-components";
import { useEffect, useState } from "react";
import { Alert } from "components/bootstrap";
import Spinner from "components/common/Spinner";
import Delayed from "./Delayed";
const Container = styled.div(
  ({ theme }) => css`
    background-color: ${theme.colors.global.contentBackground};
    position: fixed;
    min-width: 200px;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
    z-index: 2000;
  `
);
const StyledAlert = styled(Alert)`
  margin: 0;
  height: 32px;
  padding: 5px 20px;
  text-align: center;
`;
const LoadingIndicator = ({
  text = "Loading...",
  longWaitText = "This is taking a bit longer, please hold on...",
  longWaitTimeout = 2e4
}) => {
  const [indicatorText, setIndicatorText] = useState(text);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIndicatorText(longWaitText);
    }, longWaitTimeout);
    return () => clearTimeout(timeoutId);
  }, [longWaitText, longWaitTimeout]);
  return /* @__PURE__ */ React.createElement(Delayed, { delay: 500 }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "info" }, /* @__PURE__ */ React.createElement(Spinner, { delay: 0, text: indicatorText }))));
};
export default LoadingIndicator;
